import { EditSheetPage } from 'modules/sheetApproval/components/EditSheet/EditSheetPage';
import { selectEditSheetGroup } from 'modules/sheetApproval/store/selectors';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Route } from 'react-router-dom';
import { EntryType } from 'shared/models/sheet/Sheet';
import { routes } from 'shared/routes';
import ManagerSheetDetailPage from 'modules/clients/content/timeApproval/ManagerSheetDetailPage';
import { useSheetApprovalTabs } from 'modules/clients/header/useSheetApprovalTabs';
import { SheetApproval } from 'modules/sheetApproval/components/SheetApproval/SheetApproval';
import useTitleUpdate from 'shared/utils/hooks/useTitleUpdate';
import { selectCurrentClientId } from 'store/entities/clients/selectors/clientsSelectors';
import { getActivities } from 'store/entities/configuration/configurationAction';

export default function TimeApproval() {
    useTitleUpdate('Time Approval', 'Time Approval');
    useSheetApprovalTabs(EntryType.TIME);

    const dispatch = useDispatch();
    const clientId = useSelector(selectCurrentClientId);
    useEffect(() => {
        if (clientId) {
            dispatch(getActivities.init());
        }
    }, [dispatch, clientId]);

    const editSheet = useSelector(selectEditSheetGroup);
    if (editSheet) {
        return (<EditSheetPage />);
    }

    return (
        <>
            <SheetApproval sheetType={EntryType.TIME} />
            <Route path={routes.CLIENT.TIME_APPROVAL.SHEET_DETAIL}>
                <ManagerSheetDetailPage entryType={EntryType.TIME} />
            </Route>
        </>
    );
}
